/**
 * English strings of the people of a player (milestone 7, slice 9): friends, requests, blocks,
 * reports, invitations and the notices of the moderators. `social-it.ts` is typed against this shape.
 */
export const socialEn = {
  social: {
    title: 'Friends',
    intro:
      'Ask a friend for their nickname and the four digits that follow it, and send a request.',
    gate: {
      unavailable: 'Friends are not available in this version',
      unavailableBody: 'This build has no account service, which friends need.',
      signIn: 'Sign in to have friends',
      signInBody: 'Friends, invitations and blocking go with an account.',
      signInAction: 'Go to the account',
      guest: 'A guest has no friends',
      guestBody: 'Turn this guest into an account to ask people to be your friends.',
      off: 'Friends are switched off for now.',
      loading: 'Looking for your friends…',
      failed: 'Your friends could not be loaded. Try again.',
      retry: 'Try again',
    },
    add: {
      title: 'Ask somebody to be your friend',
      label: 'Nickname and digits',
      hint: 'Like Ada#0042.',
      action: 'Send the request',
      outcome: {
        requested: 'Request sent to {{name}}.',
        accepted: 'You and {{name}} are friends now.',
        already: 'You are already friends, or the request is waiting for an answer.',
        notFound: 'There is nobody by that name. Check the nickname and the four digits.',
        blocked: 'You have blocked this player. Unblock them first.',
        self: 'That is you.',
        accountRequired: 'Guests cannot have friends.',
        full: 'Your list is full, or you have too many requests waiting.',
      },
      failed: 'The request could not be sent. Try again.',
    },
    requests: {
      title: 'Requests',
      incoming: '{{name}} asks to be your friend.',
      outgoing: 'Waiting for {{name}} to answer.',
      accept: 'Accept',
      decline: 'Decline',
      cancel: 'Take it back',
    },
    friends: {
      title: 'Friends',
      empty: 'No friends yet.',
      remove: 'Remove',
      block: 'Block',
      join: 'Join',
      heists: 'Their heists',
      heistsClose: 'Hide their heists',
      heistsEmpty:
        'No heist to watch. Replays are kept for 30 days, and the daily heist is never shown.',
      heistsFailed: 'The heists could not be loaded.',
      heistDone: 'Heist done',
      heistFailed: 'Heist failed',
      heistRole: 'as {{role}}',
      watch: 'Watch',
      presence: {
        online: 'Here',
        offline: 'Away',
        lobby: 'At a table',
        playing: 'Playing',
      },
    },
    blocked: {
      title: 'Blocked players',
      empty: 'Nobody is blocked.',
      note: 'They are not told. You do not see what they write.',
      unblock: 'Unblock',
    },
    notices: {
      title: 'From the moderators',
      ban: 'Your account is suspended from online play.',
      mute: 'Your chat is muted. The quick phrases still work.',
      warn: 'You received a warning.',
      until: 'Until {{date}}.',
      forever: 'Until a moderator lifts it.',
      reason: 'Reason: {{reason}}',
    },
    notifications: {
      title: 'Latest',
      friend_request: '{{name}} asked to be your friend.',
      friend_accepted: '{{name}} accepted your request.',
      moderation: 'A moderator acted on your account.',
    },
    invite: {
      banner: '{{name}} invites you to a heist.',
      join: 'Join',
      dismiss: 'Not now',
    },
    room: {
      title: 'Invite friends',
      empty: 'None of your friends is here right now.',
      action: 'Invite',
      sent: 'Invitation sent to {{name}}.',
      error: {
        rateLimited: 'Wait a moment before inviting {{name}} again.',
        offline: '{{name}} has just gone away.',
        notInRoom: 'Invitations are for a private room that has not started.',
        notFriends: 'You are not friends with {{name}}.',
        featureOff: 'Invitations are switched off for now.',
        unreachable: 'The invitation could not be sent. Try again.',
        generic: 'The invitation could not be sent.',
      },
    },
    actions: {
      title: 'Player',
      open: 'Actions for {{name}}',
      addFriend: 'Ask to be friends',
      block: 'Block',
      report: 'Report',
      close: 'Close',
      blocked: '{{name}} is blocked. You will not see what they write.',
      failed: 'That did not work. Try again.',
    },
    report: {
      title: 'Report {{name}}',
      reason: 'What is the matter?',
      reasons: {
        chat: 'Offensive chat',
        name: 'Offensive name',
        cheating: 'Cheating',
        abandon: 'Leaves heists on purpose',
        other: 'Something else',
      },
      detail: 'Tell us more (optional)',
      send: 'Send the report',
      sent: 'Report sent. Thank you: a moderator will look at it.',
      already: 'You have already reported this player for that.',
      limit: 'You have sent many reports today. Try again tomorrow.',
      notFound: 'There is nobody by that name.',
      self: 'That is you.',
      invalid: 'The report is not valid.',
      failed: 'The report could not be sent. Try again.',
    },
  },
};
